module.exports = __webpack_public_path__ + "img/138ne.c1e4f43c.svg";